import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const DropdownMenu = styled.ul`
    position: absolute;
    width: 200px;
    border-radius: 3px;
    border: 1px solid ${({ theme }) => theme.borders.preferenceMenuLine};
    background-color: ${({ theme }) => theme.backgrounds.actionDropDown};
    z-index:9999;
    box-shadow: ${({ theme }) => theme.shadows.actionDropDown} 0 0 50px 0;
    left: 90%;
    bottom: 0px;
`;
DropdownMenu.displayName = 'DropdownMenu';

export const Hr = styled.div`
    height: 1px;
    background-color: ${({ theme }) => theme.borders.preferenceMenuLine};
`;
Hr.displayName = 'Hr';

export const UserDropdownItem = styled.li`
    list-style: none;
    text-align: left;
    color: ${({ theme }) => theme.text.actionDropDownItem};
    font-size: 14px;
    padding:10px 20px;
    font-weight: 300;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    &:hover{
        background-color: ${({ theme }) => theme.backgrounds.actionDropDownHover};
    }

    & .user_whats_new_badge {
        min-width: unset;
    }

    & a{
        color: ${({ theme }) => theme.text.actionDropDownItem};
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        width: 100%;
    }
`;
UserDropdownItem.displayName = 'DropdownItem';

export const ItemLabel = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
ItemLabel.displayName = 'ItemLabel';

export const ShortcutHint = styled.span`
    flex-shrink: 0;
    font-family: 'CentraNo2';
    font-size: 12px;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 4px;
    background: ${({ theme }) => theme.backgrounds.tableItem};
    border: 1px solid ${({ theme }) => theme.borders.tableItem};
    box-shadow: 0 1px 0 ${({ theme }) => theme.borders.tableItem};
    color: ${({ theme }) => theme.text.modalTitle2};
    white-space: nowrap;
`;
ShortcutHint.displayName = 'ShortcutHint';

export const UserAvatar = styled.div`
    position: relative;
    cursor: pointer;
`;
UserAvatar.displayName = 'UserAvatar';

export const CustomLink = styled(Link)`
    text-decoration: none !important;
    display:flex;
`;
